import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PaginationItem } from '@material-ui/lab';
import { PaginationContainer } from './main.pagination.styles';

interface PaginationProps {
  baseUrl?: string;
  count?: number;
  page?: number;
  forGrid?: boolean;
}

const MainPagination = ({ baseUrl, count, page, forGrid }: PaginationProps) => {
  const location = useLocation();

  if (!count) return null;

  const query = new URLSearchParams(location.search);

  // fetch page param & remove it from query
  const pageParam = query.get('page');
  query.delete('page');
  const currentPage = page || parseInt(pageParam || '1', 10);

  // use location & remaining query params to build final base url
  let url = baseUrl || `${location.pathname}?${query.toString()}`;
  const queryIndex = url.indexOf('?');
  url = queryIndex < 0 ? `${url}?` : url;
  url = queryIndex !== url.length - 1 ? `${url}&` : url;

  return (
    <PaginationContainer
      $forGrid={forGrid}
      page={currentPage}
      count={count}
      renderItem={(item) => <PaginationItem component={Link} to={`${url}page=${item.page}`} {...item} />}
    />
  );
};

export default MainPagination;
